<template style="font-family: Times New Roman">
  <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
    <v-row justify="center" align="center">
      <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
    </v-row>
    <v-row justify="center" align="center">
      <v-card-subtitle class="subtitle-1"
        >You do not have Permission to access.</v-card-subtitle
      >
    </v-row>
  </v-card>
  <v-card class="ma-2" v-else>
    <v-row class="mt-0 ml-3">
      <v-card-text>
        <v-row class="mt-n3">
          <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
            <v-dialog
              ref="dialogStart"
              v-model="modalStart"
              :return-value.sync="start_date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="start_date"
                  label="From"
                  append-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  class="ml-0 mx-0 lg-2 mt-1"
                ></v-text-field>
              </template>
              <v-date-picker v-model="start_date" scrollable :max="currentDate">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalStart = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="
                    setMinMaxToDate();
                    $refs.dialogStart.save(start_date);
                  "
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
            <v-dialog
              ref="dialogEnd"
              v-model="modalEnd"
              :return-value.sync="end_date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="end_date"
                  label="To"
                  append-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  class="ml-0 mx-0 lg-2 mt-1"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="end_date"
                scrollable
                :max="maxEndDate"
                :min="start_date"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalEnd = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogEnd.save(end_date)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="12" xs="12" xl="2" md="2" lg="2">
            <v-autocomplete
              dense
              class="ml-0 mx-0 lg-2 mt-1"
              item-text="name"
              item-value="value"
              :items="InitiatedFromList"
              v-model="initiatedfrom"
              label="Initiated From"
              outlined
            ></v-autocomplete>
            <!-- <v-text-field
                  dense
                  outlined
                 
                  class="ml-0 mx-0 lg-2 mt-1"
                  single-line
                  hide-details
                ></v-text-field> -->
          </v-col>
          <v-col cols="12" sm="12" xs="12" xl="2" md="2" lg="2">
            <v-autocomplete
              dense
              class="ml-0 mx-0 lg-2 mt-1"
              item-text="name"
              item-value="value"
              :items="StatusList"
              v-model="status"
              label="Status"
              outlined
            ></v-autocomplete>
            <!-- <v-text-field
                  dense
                  outlined
                 
                  class="ml-0 mx-0 lg-2 mt-1"
                  single-line
                  hide-details
                ></v-text-field> -->
          </v-col>
          <v-col cols="12" sm="12" xs="12" xl="3" md="3" lg="3">
            <v-text-field
              dense
              shaped
              outlined
              v-model="search"
              @keyup.enter="getTrailList(end_data, enddata)"
              label="Search"
              single-line
              hide-details
              class="ml-0 mx-0 lg-2 mt-1"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            xs="12"
            xl="1"
            md="1"
            lg="1"
            class="ml-n3 mt-1"
          >
            <v-btn
              small
              @click="getTrailList(start_date, end_date)"
              fab
              text
              color="dark"
              class="elevation-0"
            >
              <v-icon dark>mdi-filter</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-row>
    <v-row class="mt-n10">
      <v-col cols="12" sm="12" xs="12" xl="12" md="12" lg="12">
        <v-data-table
          :headers="headers"
          :items="apptrailList"
          dense
          item-key="name"
          :no-data-text="Nodata"
          class="ml-2"
          :options.sync="pagination"
          :items-per-page="itemsPerPage"
          @update:options="getTrailListPagination()"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">{{ apptrailList.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:[`item.initiator`]="{ item }">
            <span class="caption">{{ item.initiator }}</span
            ><br />
            <span class="caption" v-if="item.initiated_from == 1">Mobile</span>
            <span class="caption" v-if="item.initiated_from == 2"
              >Corporate</span
            >
          </template>

          <template v-slot:[`item.mobile_number`]="{ item }">
            <span class="caption"
              ><b>{{ item.mobile_number }}</b></span
            >
          </template>
          <template v-slot:[`item.user_detail`]="{ item }">
            <span class="caption"
              ><b>{{ item.user_detail }}</b></span
            >
          </template>

          <template v-slot:[`item.old_mobile_number`]="{ item }">
            <span class="caption">{{ item.old_mobile_number }}</span>
          </template>
          <template v-slot:[`item.created_on`]="{ item }">
            <span class="caption">{{ item.created_on }}</span>
          </template>
          <template v-slot:[`item.approved_by`]="{ item }">
            <span class="caption" v-if="item.approved_by != '  '">{{
              item.approved_by
            }}</span>
            <span class="caption" v-else>-</span>
            <br />
            <span class="caption">{{ item.approved_on }}</span>
          </template>
          <!-- <template v-slot:[`item.approved_on`]="{ item }">
            <span class="caption">{{ item.approved_on }}</span>
          </template> -->

          <template v-slot:[`item.status`]="{ item }">
            <span class="caption red--text" v-if="item.status == '3'"
              >Rejected</span
            >

            <span class="caption green--text" v-if="item.status == '2'"
              >Approved</span
            >
          </template>
          <template v-slot:[`item.approver_comments`]="{ item }">
            <v-tooltip bottom color="primary" class="pa-3">
              <template v-slot:activator="{ on }">
                <h4 class="caption" v-on="on">
                  {{
                    item.approver_comments.length >= 15
                      ? item.approver_comments.substr(0, 15) + "..."
                      : item.approver_comments
                  }}
                </h4>
              </template>
              <span class="caption">{{ item.approver_comments }}</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.View`]="{ item }">
            <span>
              <v-icon
                small
                class="ml-2"
                @click="showContent(item)"
                color="primary"
                >mdi-eye</v-icon
              ></span
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="ApproveDialog" persistent max-width="600px">
      <v-card>
        <v-toolbar flat class="header" dark dense>
          <v-icon small>mdi-cellphone-text</v-icon>
          <span class="ml-3 subtitle-2"
            >Mobile Number Change Request of
            {{ mobilenumberDetails.user_detail }}</span
          >

          <v-spacer></v-spacer>
          <v-icon small class="white--text" dark @click="dialogclose"
            >mdi-close</v-icon
          >
        </v-toolbar>

        <v-card-text class="pt-10">
          <v-row>
            <v-col cols="12" sm="12" xs="12" lg="12" xl="12" md="12">
              <div class="black--text text--darken-1" style="font-size: 15px">
                <div>
                  <v-row>
                    <v-col cols="12" sm="12" xl="6" md="6" lg="6">
                      <span class="subtitle-2">Old Mobile Number</span><br />
                      <span class="caption black--text">{{
                        mobilenumberDetails.old_mobile_number
                      }}</span>
                    </v-col>
                    <v-col cols="12" sm="12" xl="6" md="6" lg="6">
                      <span class="subtitle-2">New Mobile Number</span><br />
                      <span class="caption black--text">
                        {{ mobilenumberDetails.mobile_number }}</span
                      >
                    </v-col>
                    <v-col cols="12" sm="12" xl="6" md="6" lg="6">
                      <span class="subtitle-2">Initiator Comments</span><br />
                      <span class="caption black--text">
                        {{ mobilenumberDetails.initiator_comments }}</span
                      >
                    </v-col>
                    <v-col cols="12" sm="12" xl="6" md="6" lg="6">
                      <span class="subtitle-2">Approver Comments</span><br />
                      <span class="caption black--text">
                        {{ mobilenumberDetails.approver_comments }}</span
                      >
                    </v-col>
                    <v-col cols="12" sm="12" xl="6" md="6" lg="6">
                      <span class="subtitle-2">Status</span><br />
                      <span
                        class="caption red--text"
                        v-if="mobilenumberDetails.status == 3"
                      >
                        Rejected
                      </span>
                      <span
                        class="caption green--text"
                        v-if="mobilenumberDetails.status == 2"
                      >
                        Approved
                      </span>
                    </v-col>
                  </v-row>
                </div>
                <br />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <OverleyProccessg :overlay="overlay" />
  </v-card>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import moment from "moment";

import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    itemsPerPage: 15,
    StatusList: [
      { name: "All", value: 0 },
      { name: "Approved", value: 2 },
      { name: "Rejected", value: 3 },
    ],
    status: 0,
    InitiatedFromList: [
      { name: "All", value: 0 },
      { name: "Mobile", value: 1 },
      { name: "Corporate", value: 2 },
    ],
    initiatedfrom: 0,
    checkaccessdata: {},
    search: "",
    overlay: false,
    headers: [
      { text: "Sl No", value: "sl_no", width: "50px" },
      {
        text: "App User Name",
        value: "user_detail",
        width: "50px",
      },
      {
        text: "Initiated By / From",
        value: "initiator",
        width: "50px",
      },
      //   {
      //     text: "Initiated From",
      //     value: "initiated_from",
      //     align: "start",
      //     width: "50px",
      //     sortable: false,
      //   },
      //   {
      //     text: "Initiated On",
      //     value: "created_on",
      //     width: "50px",
      //   },
      {
        text: "Old Mobile Number",
        value: "old_mobile_number",
        width: "50px",
      },
      {
        text: "New Mobile Number",
        value: "mobile_number",
        width: "50px",
      },
      {
        text: "Action Taken By / On",
        value: "approved_by",
        width: "50px",
      },
      //   {
      //     text: "Approved On",
      //     value: "approved_on",
      //     width: "50px",
      //   },
      // {
      //   text: "Approver Comments",
      //   value: "approver_comments",
      //   width: "100px",
      // },

      {
        text: "Status",
        value: "status",
        width: "50px",
      },
      {
        text: "Action",
        value: "View",
        width: "50px",
      },
    ],
    modalEnd1: false,
    modalEnd: false,
    modalStart: false,
    end_date: null,
    start_date: null,
    Nodata: "",
    apptrailList: [],
    maxEndDate: null,
    comments: "",
    Namerules: [(v) => !!v || "Required"],
    ApproveDialog: false,
    mobilenumberDetails: {},
  }),
  created() {
    this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date = new Date().toISOString().substr(0, 10);
    this.currentDate = moment().format("YYYY-MM-DD");
    this.maxEndDate = this.end_date;
    this.checkaccess();
  },
  methods: {
    setMinMaxToDate() {
      let tempMaxDate = moment(this.start_date, "YYYY-MM-DD")
        .add(12, "months")
        .format("YYYY-MM-DD");
      this.maxEndDate =
        this.currentDate < tempMaxDate ? this.currentDate : tempMaxDate;

      this.end_date = this.maxEndDate;
    },
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CUSERS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getTrailList(this.start_date, this.end_date);
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },
    async getTrailList() {
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETMOBCHNHISTORY",
          corp_id: this.$store.getters.get_corpid,
          initiated_from: this.initiatedfrom,
          status: this.status,
          search_text: this.search,
          from_date: this.start_date,
          to_date: this.end_date,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.apptrailList = responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        }
      } else if (responseData.data.status == "NOREC") {
        this.apptrailList = [];
        this.Nodata = responseData.data.status_msg;
      }
      //  console.log("getuserdeatils", responseData);
    },
    async getTrailListPagination() {
      if (this.apptrailList.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;
        var inputData = {
          method_name: "CARDS",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "GETMOBCHNHISTORY",
            corp_id: this.$store.getters.get_corpid,
            initiated_from: this.initiatedfrom,
            status: this.status,
            search_text: this.search,
            from_date: this.start_date,
            to_date: this.end_date,
          },
        };
        var responseData = await apiCall(inputData);
        this.apptrailList = this.apptrailList.concat(responseData.data.data);
      }
    },
    showContent(item) {
      // console.log(item);
      this.mobilenumberDetails = item;
      this.ApproveDialog = true;
    },
    dialogclose() {
      this.ApproveDialog = false;
      this.$refs.form.reset();
    },
    async ApproveReject(value) {
      if (value == 2) {
        var inputData = {
          method_name: "CARDS",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "APPROVEREQ",
            user_id: this.mobilenumberDetails.user_id,
            mobile_number: this.mobilenumberDetails.mobile_number,
            comments: this.comments,
            approval_status: 2,
            logged_user_id: this.$store.getters.get_userid,
            initiated_by: this.mobilenumberDetails.initiatedby,
            initiated_from: this.mobilenumberDetails.initiated_from,
          },
        };
        var responseData = await apiCall(inputData);
        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.ApproveDialog = false;
          this.getTrailList();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.ApproveDialog = false;
        }
      }
      if (value == 1) {
        var inputData1 = {
          method_name: "CARDS",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "APPROVEREQ",
            user_id: this.mobilenumberDetails.user_id,
            mobile_number: this.mobilenumberDetails.mobile_number,
            comments: this.comments,
            approval_status: 3,
            logged_user_id: this.$store.getters.get_userid,
            initiated_by: this.mobilenumberDetails.initiatedby,
            initiated_from: this.mobilenumberDetails.initiated_from,
          },
        };
        var responseData1 = await apiCall(inputData1);
        if (responseData1.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData1.data.status_msg,
            color: "green",
          });
          this.ApproveDialog = false;
          this.getTrailList();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData1.data.status_msg,
            color: "red",
          });
          this.ApproveDialog = false;
        }
      }
    },
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
